import React from 'react';

import classes from './Layout.css';
import Aux from '../../hoc/_Aux';
//import Header from '../Header/Header'
//import Footer from '../Footer/Footer'

const layout = ( props ) => (
    <Aux>
        {/* <Header/> */}
        <main className={classes.Content}>
            {props.children}
        </main>
        {/* <Footer/>        */}
    </Aux>
);

export default layout;